import React from 'react';
import List from './components/List';
import onKeyDown from './EventHandlers';
import ListItemPlugin from './ListItemPlugin';
import { type EditorPlugin } from '../../types/aha-editor';

const ListComponentPluginFactory = (
  listType: string,
  elementType: 'ul_list' | 'ol_list' | 'checklist' | 'dl_list'
): EditorPlugin => ({
  name: `${listType} List component plugin`,
  dependencies: [ListItemPlugin],
  component: {
    type: elementType,
    component: ({ attributes, children, ...props }) => (
      <List type={listType} {...attributes} {...props}>
        {children}
      </List>
    ),
  },
});

export const UnorderedListComponentPlugin = ListComponentPluginFactory(
  'ul',
  'ul_list'
);
export const OrderedListComponentPlugin = ListComponentPluginFactory(
  'ol',
  'ol_list'
);
export const CheckboxListComponentPlugin = ListComponentPluginFactory(
  'checklist',
  'checklist'
);
export const DefinitionListComponentPlugin = ListComponentPluginFactory(
  'dl',
  'dl_list'
);

export const ListKeydownHandlerPlugin = {
  name: 'List Keydown handler plugin',
  handlers: {
    onKeyDown,
  },
};

const ListComponentsPlugin = [
  ListKeydownHandlerPlugin,
  UnorderedListComponentPlugin,
  OrderedListComponentPlugin,
  CheckboxListComponentPlugin,
  DefinitionListComponentPlugin,
];

export default ListComponentsPlugin;
